/* Bandenmeesters 2.1 — homepage interactions only. */
(()=>{
  'use strict';

  function initWheelGuide(root=document){
    root.querySelectorAll?.('[data-bm-wheel-guide]').forEach((section)=>{
      if(section.dataset.bmGuideReady) return;
      section.dataset.bmGuideReady='true';

      const buttons=[...section.querySelectorAll('[data-bm-guide-part]')];
      const panels=[...section.querySelectorAll('[data-bm-guide-panel]')];
      if(!buttons.length||!panels.length) return;

      const activate=(key)=>{
        buttons.forEach((button)=>{
          const active=button.dataset.bmGuidePart===key;
          button.classList.toggle('is-active',active);
          button.setAttribute('aria-selected',active?'true':'false');
          button.tabIndex=active?0:-1;
        });
        panels.forEach((panel)=>{panel.hidden=panel.dataset.bmGuidePanel!==key;});
      };

      buttons.forEach((button,index)=>{
        const activateButton=()=>activate(button.dataset.bmGuidePart);
        button.addEventListener('mouseenter',activateButton);
        button.addEventListener('focus',activateButton);
        button.addEventListener('click',activateButton);
        button.addEventListener('keydown',(event)=>{
          if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          const direction=event.key==='ArrowLeft'||event.key==='ArrowUp'?-1:1;
          const next=buttons[(index+direction+buttons.length)%buttons.length];
          next.focus();
          activate(next.dataset.bmGuidePart);
        });
      });

      activate(buttons[0].dataset.bmGuidePart);
    });
  }

  const init=(root=document)=>{
    initWheelGuide(root);
  };

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
  else init();

  document.addEventListener('shopify:section:load',(event)=>init(event.target));
})();
